const memberInfo = {};

memberInfo.set = function (initData) {
    this.isLoggedIn = initData.isLoggedIn;
    this.memberId = initData.memberId;
    this.memberAlias = initData.memberAlias;
};

memberInfo.reset = function () {
    this.isLoggedIn = null;
    this.memberId = null;
    this.memberAlias = null;
};

export default memberInfo;
